import {z} from 'zod'
import {createNumericKeyRecordSchema} from '../OptionalNumericKeyRecordSchema.ts'
import {createPartialStrictObjectSchemaWithAtLeastOneProperty} from '../PartialStrictObjectSchema.ts'
import {validateState} from '../ValidateState.ts'
import {PlayerColor} from '../PlayerState.ts'

// CornerVariables: https://prntscr.com/w5qvpk
export enum TileCornerDirection {
    North = 0,
    South = 1,
}

export enum TileCornerBuildingType {
    Settlement = 1,
    City = 2,
    DestroyedCity = 3,
    KnightActiveLevel1 = 4,
    KnightActiveLevel2 = 5,
    KnightActiveLevel3 = 6,
    KnightInactiveLevel1 = 7,
    KnightInactiveLevel2 = 8,
    KnightInactiveLevel3 = 9,
}

export enum TileCornerBonusType {
    IslandSettlingChits = 0,
    CityWall = 1,
    MetropolisScience = 2,
    MetropolisTrade = 3,
    MetropolisPolitics = 4,
}

export const tileCornerStateSchema = z
    .object({
        x: z.number().int().readonly(),
        y: z.number().int().readonly(),
        z: z.enum(TileCornerDirection).readonly(),
        owner: z.enum(PlayerColor).exclude(['None']).optional(),
        buildingType: z.enum(TileCornerBuildingType).optional(),
        bonuses: z.array(z.enum(TileCornerBonusType)).optional(),
        restrictedStartingPlacement: z.literal(true).optional(),
    })
    .strict()

export type TileCornerState = z.infer<typeof tileCornerStateSchema> & {
    readonly x: number
    readonly y: number
    readonly z: TileCornerDirection
}

export function validateTileCornerState(data: unknown) {
    return validateState(tileCornerStateSchema, data)
}

export const tileCornerStatesSchema = createNumericKeyRecordSchema(tileCornerStateSchema)
export type TileCornerStates = z.infer<typeof tileCornerStatesSchema>

export function validateTileCornerStates(data: unknown) {
    return validateState(tileCornerStatesSchema, data)
}

export const tileCornerStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(tileCornerStateSchema)

export type TileCornerStatePartial = z.infer<typeof tileCornerStatePartialSchema> & {
    readonly x?: number
    readonly y?: number
    readonly z?: TileCornerDirection
}

export function validateTileCornerStatePartial(data: unknown) {
    return validateState(tileCornerStatePartialSchema, data)
}

export const tileCornerStatesPartialSchema = createNumericKeyRecordSchema(tileCornerStatePartialSchema, {
    requireAtLeastOneEntry: true,
})
export type TileCornerStatesPartial = z.infer<typeof tileCornerStatesPartialSchema>

export function validateTileCornerStatesPartial(data: unknown) {
    return validateState(tileCornerStatesPartialSchema, data)
}
